import { type ReactNode } from 'react'
import { cn } from '@/lib/utils'

// Placeholder document rayé (port de StripeFill — handoff KYC).
// Remplacé par le scan réel (URL S3 présignée) à l'intégration.
export function StripeFill({ children, className }: { children?: ReactNode; className?: string }) {
  return (
    <div
      className={cn('flex items-center justify-center bg-ink', className)}
      style={{
        backgroundImage:
          'repeating-linear-gradient(45deg, transparent, transparent 7px, rgba(255,255,255,0.05) 7px, rgba(255,255,255,0.05) 14px)',
      }}
    >
      {children}
    </div>
  )
}
